.arrow-icon {
  width: 18px;
  color: var(--grey-800);
}

.arrow-icon-container {
  min-width: 20px;
}
